export default __webpack_public_path__ + "static/media/15093@2x.63d627f5.png";